//#region Styles
import {
	Part,
	Row,
	Column,
	ResumeSection,
	TitleSection2,
} from "components/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import PenIcon from "icons/PenIcon";
import DataField from "views/components/Detail/DataField/DataField";
import LocationDataField from "views/components/Detail/LocationDataField/LocationDataField";
import ListDataField from "views/components/Detail/ListDataField/ListDataField";
import ToComplete from "views/components/Detail/ToComplete/ToComplete";
//#endregion
//#region Utils
import { EVENTS_CONSTANTS, LOCATION_IDS, PUBLIC_LOADS_IDS } from "config/constants";
//#endregion

const ResumeStep2 = ({
	data, eventTypeId,
	organizers,
	teacherAccounts,
	locations,
	inscriptionEventTypes,
	allCampus,
	campusEnvironments,
	modalities,
	toStep,
	cannotUpdate,
}) => {
	const renderPayGradeField = dataPart => {
		if (eventTypeId !== EVENTS_CONSTANTS.EVENT_TYPES.WORK_SHOP) return;
		dataPart[0].splice(2, 0, {
			field: "Categoría salarial:",
			description: data.payGradeId || "-",
			mini: true,
		});
	};
	function renderTeacherFields(dataPart) {
		const { teacher } = data;
		if (teacher.search) {
			dataPart[0].splice(1, 0, {
				field: "Docente a cargo:",
				description: teacher.search.fullName,
				render: !teacher.search.fullName && <ToComplete />,
			});
			return;
		}
		if (!teacher.free) return;
		dataPart[0].splice(1, 0, {
			field: "Ponente a cargo:",
			description: teacher.free.fullName,
			render: !teacher.free.fullName && <ToComplete />,
		});
		const account = teacherAccounts.find(
			({ id }) => id === teacher.free.accountId
		);
		if (account)
			dataPart[0].splice(2, 0, {
				field: "Cuenta:",
				description: account.email,
			});
	}
	function renderLocationFields(dataPart) {
		const { locationId, zoomInscriptionTypeId, place } = data;
		if (locationId === LOCATION_IDS.ZOOM) {
			dataPart[0].splice(3, 0, {
				field: "Modo de inscripción para el evento:",
				description: inscriptionEventTypes.find(
					({ id }) => id === zoomInscriptionTypeId
				)?.name,
				mini: true,
			});
			return;
		}
		if (locationId !== LOCATION_IDS.PLACE || !place) return;
		const { campus, environment } = place;
		const { inCampus, outCampus } = environment;
		if (inCampus) {
			const { floor, address } = inCampus;
			dataPart[1].push({
				field: "Campus:",
				render: <ListDataField data={[campus.name]} />,
			});
			const inCampusName = campusEnvironments.find(item => {
				return item.id === environment.inCampus.id;
			}).name;
			dataPart[1].push({
				field: "Ambiente:",
				render: (
					<ListDataField data={[`${inCampusName} - ${address}`]} />
				),
			});
			dataPart[1].push({
				field: "Piso:",
				description: floor,
			});
		} else if (outCampus) {
			dataPart[1].push({
				field: "Campus:",
				render: <ListDataField data={[campus.name]} />,
			});
			dataPart[1].push({
				field: "Ambiente:",
				render: (
					<ListDataField
						data={[
							`${outCampus.internalOrExternal} - ${outCampus.address}`,
						]}
					/>
				),
			});
		}
	}
	function renderPublicLoadFields(dataPart) {
		const { publicLoad } = data;
		if (publicLoad.id === PUBLIC_LOADS_IDS.GENERAL) {
			dataPart[1].splice(0, 0, {
				field: "Público:",
				description: `Estudiantes ${
					modalities.find(({ id }) => {
						return id === publicLoad.students.modalityId;
					}).name
				}`,
			});
			dataPart[1].splice(1, 0, {
				field: "De todos los campus:",
				render: (
					<ListDataField
						data={publicLoad.students.publicByCampusIds.map(
							publicCampusId => {
								return allCampus.find(({ id }) => {
									return id === publicCampusId;
								}).name;
							}
						)}
					/>
				),
			});
			return;
		}
		if (publicLoad.id === PUBLIC_LOADS_IDS.FILE) {
			dataPart[1].splice(0, 0, {
				field: "Público:",
				description: "Archivo adjunto",
				render: (
					<span>
						<strong>{publicLoad.list.studentsFile.name}</strong>
					</span>
				),
			});
		}
	}
	const getDataPart = () => {
		const { organizerId, locationId, zoomLink, quantityVacancy, placeOrganization } = data;
		const organizerName = organizers.find(
			({ id }) => id === organizerId
		)?.name;
		const location = locations.find(({ id }) => id === locationId);
		const dataPart = [
			[
				{
					field: "Organizado por:",
					description: organizerName,
					render: !organizerName && <ToComplete />,
				},
				{
					field: "Ubicación:",
					render: location ? (
						<LocationDataField
							zoomLink={zoomLink}
							location={location}
						/>
					) : (
						<ToComplete />
					),
				},
				{
					field: "Vacantes:",
					description: quantityVacancy,
					render: !quantityVacancy && <ToComplete />,
				},
				{
					field: "Campus Organizador:",
					description: placeOrganization?.campus?.name,
					render: !placeOrganization?.campus?.name && <ToComplete />,
				},
			],
			[],
		];
		renderTeacherFields(dataPart);
		renderPayGradeField(dataPart);
		renderLocationFields(dataPart);
		renderPublicLoadFields(dataPart);
		return dataPart;
	};
	return (
		<Part>
			<Row>
				<TitleSection2>Organización, ubicación y público</TitleSection2>
				{!cannotUpdate && (
					<CustomButton
						variant="quintinary"
						text="Editar sección"
						icon={<PenIcon />}
						onClick={toStep}
					/>
				)}
			</Row>
			<ResumeSection>
				<Part direction="row">
					{data &&
						getDataPart().map((row, idx1) => {
							return (
								<Column
									key={idx1}
									gap="20px"
									width="45%"
								>
									{row.map((item, idx2) => {
										return (
											<DataField
												key={idx2}
												{...item}
											/>
										);
									})}
								</Column>
							);
						})}
				</Part>
			</ResumeSection>
		</Part>
	);
};

export default ResumeStep2;
